// About.js
import React from 'react';
import Header from './Header';
import Info from './Info';
import Footer from './Footer';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoginPage from '../Login/LoginPage';
import { Outlet } from 'react-router-dom';

const About = ({ refresh }) => {
  const isDesktop = useMediaQuery('(min-width:600px)');
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#050035', // Blended color of navy blue and black
    scrollY: 'hidden',
    minHeight: isDesktop ? '70vh' : '175vh'
  };

  const contentStyle = {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    color: '#fff'
  };
  const footerStyle = {
    // marginTop: 'auto', // Push the footer to the bottom
    padding: '10px',
    backgroundColor: '#333',
    // textAlign: 'center',
    color: '#fff',
  };
  return (
    <div style={containerStyle}>
      <LoginPage onRefresh={refresh} />
    </div>
  );
};

export default About;
